// The website was migrated from its own backend to the mobile app's shared
// backend so users have one account across web + mobile. A single endpoint
// (`/api/contact`, powered by Resend) still lives on the LEGACY backend and
// hasn't been ported yet — so the Contact form uses this dedicated axios
// instance while everything else uses `useAuth().api`.
import axios from "axios";

const LEGACY = process.env.REACT_APP_LEGACY_BACKEND_URL;
export const legacyApi = axios.create({
  baseURL: LEGACY ? `${LEGACY}/api` : "/api",
  timeout: 15000,
});
